<template>
    <div class="a">
        <top></top>
        <navs></navs>
        <div class="content">
            <div class="b">
                <div class="left">
                    <div class="cont">
                        <div class="cont_a" >
                            <div class="cont_left">
                                <div class="bule"></div>
                                <h2 @click="zdzt">日常证道</h2>
                            </div>
                            <div class="cont_right" @click="zdzt">
                                更多&nbsp;>>
                            </div>
                        </div>
                        <div style="display: flex;overflow: hidden;flex-wrap: wrap;height: 163px;">
                            <div class="cont_b" @click="zdzts(item.id)" v-for="(item,index) in list" :key="index">
                                <div class="cont_top">
                                    <img :src="item.placard" alt=""  width="100%" height="127px">
                                </div>
                                <div class="cont_bottom">
                                    <div class="center">
                                        {{ item.name }}
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="cont_b">
                                <div class="cont_top">

                                </div>
                                <div class="cont_bottom">
                                    <div class="center">
                                        直播入口
                                    </div>
                                </div>
                            </div>
                            <div class="cont_b">
                                <div class="cont_top">

                                </div>
                                <div class="cont_bottom">
                                    <div class="center">
                                        直播入口
                                    </div>
                                </div>
                            </div> -->
                        </div>

                    </div>
                    <div class="cont">
                        <div class="cont_a" >
                            <div class="cont_left">
                                <div class="bule"></div>
                                <h2 @click="jzzt">查经系列</h2>
                            </div>
                            <div class="cont_right" @click="jzzt">
                                更多&nbsp;>>
                            </div>
                        </div>
                        <div style="display: flex;overflow: hidden;flex-wrap: wrap;height: 163px;">
                            <div class="cont_b" @click="jzzts(item.id)" v-for="(item,index) in lists" :key="index">
                                <div class="cont_top">
                                    <img :src="item.placard" alt=""  width="100%" height="127px">
                                </div>
                                <div class="cont_bottom">
                                    <div class="center">
                                        {{ item.name }}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="right">
                    <div class="cont">
                        <div class="cont_a" >
                            <div class="cont_left">
                                <div class="bule"></div>
                                <h2 @click="zmzt">专题证道</h2>
                            </div>
                            <div class="cont_right" @click="zmzt">
                                更多&nbsp;>>
                            </div>
                        </div>
                        <div style="display: flex;overflow: hidden;flex-wrap: wrap;height: 163px;">
                            <div class="cont_b" @click="zmzts(item.id)" v-for="(item,index) in plist" :key="index">
                                <div class="cont_top">
                                    <img :src="item.placard" alt=""  width="100%" height="127px">
                                </div>
                                <div class="cont_bottom">
                                    <div class="center">
                                        {{ item.name }}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="cont">
                        <!-- <div class="cont_a"></div> -->
                        <div class="book" >
                            <div class="download" @click="zlxz" style="border-bottom: 1px solid #EEEEEE;">
                                <p>资料专区（专辑下载）</p><p>》</p>
                            </div>
                            <div class="download"  style="color: #1463FF;">
                                <p>资料下载专区请输入文本</p>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <el-dialog title="手机号登录" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="手机号码" :label-width="formLabelWidth">
                    <el-input v-model="form.phone" autocomplete="off" style="width: 300px;"></el-input>
                </el-form-item>
                <!-- <el-form-item label="图片验证" :label-width="formLabelWidth">
                    <el-input v-model="form.captcha" autocomplete="off" style="width: 300px;"></el-input>
                    <img :src="img" alt="" @click="captcha" style="height: 20px;width: 100px;">
                </el-form-item> -->
                <el-form-item label="短信验证" :label-width="formLabelWidth">
                    <el-input v-model="form.dx" autocomplete="off" style="width: 300px;"></el-input>
                    <el-button :disabled="countdown > 0" @click="startCountdown">
    {{ countdown > 0 ? countdown + '秒' : '发送验证码' }}
  </el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">登 录</el-button>
            </div>
        </el-dialog>
        <bottom></bottom>
    </div>
</template>
<script>
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
import { preach ,witness,praise} from "../api"
export default {
    components: {
        top,
        bottom,
        navs
    },
    data(){
        return{
            list:[],
            lists:[],
            plist:[],
            form: {
                phone: '',
                captcha: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
            formLabelWidth: '120px',
            img: "https://www.jnccljh.com/api/images",
            dialogFormVisible: false,
            countdown: 0,
      timer: null
        }
    },
    created(){
        preach().then(res=>{
            console.log(res)
            this.list = res.data.data.records
        })
        witness().then(res=>{
            this.lists=res.data.data.records
        })
        praise().then(res=>{
            this.plist=res.data.data.records
        })
    },
    methods: {
        submit() {
            this.dialogFormVisible = false
            const data = { "account": this.form.phone, thirdType: "SMS", mobileText: this.form.dx };
            axios.post('https://www.jnccljh.com/api/login', data).then(res => {
                console.log(res)
                if (res.data.data.accessToken != "") {
                    this.$message({
                        message: '登录成功',
                        type: 'success'
                    });
                    localStorage.setItem("token", res.data.data.accessToken)
                }
            })
        },
        startCountdown() {
            if(this.form.phone == ""){
                this.$message({
                    message: '请输入手机号',
                    type:"error"
                })
                return
            }
            // 调用发送验证码接口
            const data = { "account": this.form.phone };
            axios.post('https://www.jnccljh.com/api/sms', data);
            this.countdown = 59;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
            // getyz({

            //         "captchaCode": this.form.captcha
            // }).then(res=>{
            //     console.log(res)
            // })
            // axios({
            //     method: "POST",
            //     url: "https://www.jnccljh.com/api/sms",
            //     params: {
            //         "account": this.form.phone,
            //         "captchaCode": this.form.captcha
            //     }
            // }).then(res => {
            //     console.log(res)

            // })
        },
        zdzt(){
            this.$router.push({path:"/zdzt"})
        },
        zdzts(item){
            console.log(localStorage.getItem("token"))
            if (localStorage.getItem("token") != null) {
                this.$router.push({path:"/yzlh",query:{id:item}})
            } else {
                this.dialogFormVisible = true
            }

        },
        yzlh(){
            this.$router.push({path:"/yzlh"})
        },
        yzlhs(item){
            console.log(localStorage.getItem("token"))
            if (localStorage.getItem("token") != null) {
                this.$router.push({path:"/lh",query:{id:item}})
            } else {
                this.dialogFormVisible = true
            }

        },
        jzzt(){
            this.$router.push({path:"/jzzt"})
        },
        jzzts(item){
            console.log(localStorage.getItem("token"))
            if (localStorage.getItem("token") != null) {
                this.$router.push({path:"/jzyzlh",query:{id:item}})
            } else {
                this.dialogFormVisible = true
            }

        },
        zmzt(){
            this.$router.push({path:"/zmzt"})
        },
        zmzts(item){
            console.log(localStorage.getItem("token"))
            if (localStorage.getItem("token") != null) {
                this.$router.push({path:"/zmyzlh",query:{id:item}})
            } else {
                this.dialogFormVisible = true
            }

        },
        zlxz(){
            this.$router.push({path:"/zlxz"})
        }
    },
    beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  watch: {
       countdown: {
           handler(newVal) {
               this.countdown = newVal
           }
       }
   }
}
</script>
<style scoped>
.a {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
    padding: 0;
    background-color: #F7F7F7;
}

.content {
    width: 100%;
    height: 480px;
    background-image: url(../image/back1.png);
    padding-top: 40px;
    padding-bottom: 40px;
}

.b {
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}

.left {
    width: 45%;
    height: 480px;
    display: flex;
    flex-direction: column;
}

.cont {
    width: 100%;
    height: 240px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.cont_a {
    width: 100%;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.cont_left {
    width: 2.5rem;
    display: flex;
    align-items: center;
}

.bule {
    width: 5px;
    height: 16px;
    background: #1463FF;
    margin-right: 5px;
}

.cont_right {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #666666;
    line-height: 11px;
    font-style: normal;
}

.cont_b {
    width: 31%;
    height: 163px;
    background: #FFFFFF;
    box-shadow: 4px 4 6px 0px rgba(75, 98, 168, 0.3);
    margin-left: 2%;
    /* margin-bottom: 40px; */
}
.cont_b:hover{
    width: 31%;
    height: 163px;
    background: #FFFFFF;
    box-shadow: 4px 4 6px 0px rgba(75,98,168,0.53);
    transform:translateY(-5px);
    margin-left: 2%;
    /* margin-bottom: 46px; */
}
.cont_bottom:hover{
    height: 36px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1463FF;
    color: #FFFFFF;
}
.cont_left:hover{
    color: #1463FF;
}
.cont_right:hover{
    color: #1463FF;
}
.cont_top {
    width: 100%;
    height: 127px;
}

.cont_bottom {
    height: 36px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.center {
    width: 1.2625rem;
    height: 36px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: .1375rem;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}
.right{
    width: 45%;
    height: 480px;
    display: flex;
    flex-direction: column;
}
.information{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}
.infor{
    width: 45%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}
.cont_text{
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
font-weight: 500;
}
.hidden{
    width: 100%;
white-space: nowrap;
text-overflow: ellipsis;
overflow: hidden;
font-weight: 400;
font-size: 11px;
color: #666666;
}
.book{
    width: 100%;
    height: 180px;
    background-color: #FFFFFF;
}
.download{
    width: 80%;
    margin: 0 auto;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 11px;
color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/views/sm.vue